import useResident from './useResident'

/**
 * The service user's full name, or undefined if the service user is not found.
 */
export const useResidentFullName = (id?: string): string | undefined => {
  const { resident } = useResident({ id })

  if (!resident?.name) {
    return undefined
  }

  return [resident.name.first, resident.name.last]
    .filter(Boolean)
    .join(' ')
    .trim()
}

export default useResidentFullName
